import { flowRestartPolicies } from '@deity-io/di-data-flows';
import { Box, FlexLayout, H3, Input, Select } from '@deity-io/portal-ui';
import { FlowActionTypes, FlowContext } from 'contexts/FlowContext';
import type React from 'react';
import { useContext } from 'react';

type FlowSettingsProps = {};

export const FlowSettings: React.FC<FlowSettingsProps> = () => {
  const ctx = useContext(FlowContext);
  const flow = ctx?.state.flow;

  return (
    <FlexLayout p="xxl" flexDirection="column" sx={{ paddingLeft: '50px', paddingRight: '50px' }}>
      <H3>Restart policy</H3>

      <Box style={{ width: '50%' }}>
        <Select
          label="Restart policy"
          sx={{ marginY: 1 }}
          onChange={(val: any) => {
            ctx?.dispatch({
              type: FlowActionTypes.UPDATE_FLOW_SETTING,
              payload: { property: 'restart', value: val?.value }
            });
          }}
          options={[
            flowRestartPolicies.always,
            flowRestartPolicies.onFailure,
            flowRestartPolicies.unlessStopped,
            flowRestartPolicies.no
          ]?.map(p => ({
            value: p,
            label: p
          }))}
          value={{ label: ctx?.state?.flowSchema?._meta.restart, value: ctx?.state?.flowSchema?._meta.restart }}
          disabled={ctx?.state.locked}
          autoComplete={false}
        />
      </Box>
      <H3>GQL Mutation</H3>

      <Input
        value={flow?.config['mutation'] || ''}
        helperText="Enter a name to enable the flow to be used as gql Mutation."
        label="Mutation name"
        disabled={ctx?.state.locked}
        onChange={e => {
          // eslint-disable-next-line no-console
          console.log('mutation', e.target.value, e);
          ctx?.dispatch({
            type: FlowActionTypes.UPDATE_FLOW_SETTING,
            payload: { property: 'mutation', value: e.target.value }
          });
        }}
      />

      <H3>GQL Query</H3>

      <Input
        helperText="Enter a name to enable the flow to be used as gql Query."
        label="Query name"
        value={flow?.config['query'] || ''}
        disabled={ctx?.state.locked}
        onChange={e => {
          // eslint-disable-next-line no-console
          console.log('query', e.target.value, e);
          ctx?.dispatch({
            type: FlowActionTypes.UPDATE_FLOW_SETTING,
            payload: { property: 'query', value: e.target.value }
          });
        }}
      />
    </FlexLayout>
  );
};
